import { registerQuery } from 'data-fetching-client';
import { fetchObjectTypes } from '../api/framework-data';
export const fetchObjectsQuery = registerQuery({
  fetcher: fetchObjectTypes,
  fieldName: 'objects'
});